import Icon from '../../components/Icon.vue'

Icon.register({"brands/stack-exchange":{"width":448,"height":512,"paths":[{"d":"M17.7 332.3H430.4V354.3C430.4 392 401.1 422.3 365.1 422.3H346.1L259.3 512V422.3H83C47 422.3 17.7 392 17.7 354.3V332.3zM17.7 308.7H430.4V223.7H17.7V308.7zM17.7 199.3H430.4V114.3H17.7V199.3zM365 0H83C47 0 17.7 30.3 17.7 67.7V90H430.4V67.7C430.3 30.3 401 0 365 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/stack-exchange.js
// module id = null
// module chunks = 